module.exports = __webpack_public_path__ + "static/media/ic_sync.73fffd85.svg";